/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckA2Icon20Light = forwardRef('CheckA2Icon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M15.581 5.51a.5.5 0 1 0-.707-.707l-8.54 8.54c-.58.58-1.52.58-2.1 0l-3.17-3.17a.5.5 0 0 0-.708.707l3.171 3.17c.97.97 2.543.97 3.514 0l8.54-8.54Z" }),
        React.createElement("path", { d: "M19.832 5.51a.5.5 0 0 0-.707-.707l-9.093 9.092a.5.5 0 0 0 .707.707l9.093-9.092Z" })));
});
